import React, { Fragment, useEffect } from "react";

import { FullPageLoader } from "@components/Loader";
import { BASE_DASHBOARD_URL } from "config/index";
import { useRouter } from "next/router";
import { useAppSelector } from "store/hooks";

function GuestGuard({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  const { isLoggedIn } = useAppSelector((state) => state.user);
  const router = useRouter();
  const { next } = router.query;

  useEffect(() => {
    if (isLoggedIn) {
      router.replace((next as string) || BASE_DASHBOARD_URL);
    }
  }, [isLoggedIn, router, next]);

  if (isLoggedIn || !router.isReady) return <FullPageLoader />;

  return <Fragment>{children}</Fragment>;
}

export default GuestGuard;
